<template>
  <div class="birthplace-map-widget">
    <p>Click the map to mark your birthplace</p>
    <div class="map-wrapper">
      <ol-map
        ref="mapRef"
        style="width: 100%; height: 100%"
        @click="handleMapClick"
      >
        <ol-view :center="center" :zoom="zoomLevel" projection="EPSG:4326" />

        <ol-tile-layer>
          <!-- Keyed provider in prod, OSM on a dev box (utils/map-tiles). -->
          <ol-source-xyz v-if="tiles.keyed" :url="tiles.url" :attributions="tiles.options.attribution" :max-zoom="tiles.options.maxZoom" :tile-load-function="tiles.options.tileLoadFunction" />
          <ol-source-osm v-else />
        </ol-tile-layer>

        <ol-vector-layer>
          <ol-source-vector>
            <ol-feature v-if="lat !== null && lng !== null">
              <!-- custom style: big red circle with white outline -->
              <ol-style>
                <ol-style-circle :radius="8">
                  <ol-style-fill color="#E53935" />
                  <ol-style-stroke color="#FFFFFF" :width="3" />
                </ol-style-circle>
              </ol-style>
              <ol-geom-point :coordinates="[lng, lat]" />
            </ol-feature>
          </ol-source-vector>
        </ol-vector-layer>
      </ol-map>
    </div>
  </div>
</template>


<script>
import { ref, computed, watch } from "vue";
import { static_store } from "@/store";
import { tileSource } from "@/utils/map-tiles";
export default {
  emits: ["submit"],
  props: {
    // { latitude, longitude } | null — the seeker's saved birthplace.
    initialCoordinates: { type: Object, default: null },
  },
  setup(props, { emit }) {
    // Neutral default view (continental US) shown with NO marker until the
    // seeker actually has — or picks — a birthplace.
    const DEFAULT_CENTER = [-98.5, 39.5];
    const DEFAULT_ZOOM = 3;

    const coords = (c) =>
      (c && c.latitude != null && c.longitude != null
        && !isNaN(Number(c.latitude)) && !isNaN(Number(c.longitude)))
        ? [Number(c.longitude), Number(c.latitude)] : null;

    const seed = coords(props.initialCoordinates);
    const lat = ref(seed ? seed[1] : null);
    const lng = ref(seed ? seed[0] : null);
    const mapRef = ref(null);

    const center = computed(() =>
      (lat.value !== null && lng.value !== null) ? [lng.value, lat.value] : DEFAULT_CENTER);
    const zoomLevel = computed(() => (lat.value !== null ? 6 : DEFAULT_ZOOM));

    // The store/profile can load AFTER mount; seed the marker when it arrives,
    // but never clobber a pin the seeker already dropped.
    watch(() => props.initialCoordinates, (c) => {
      const p = coords(c);
      if (p && lat.value === null) { lng.value = p[0]; lat.value = p[1]; }
    });

    function handleMapClick(e) {
      const [clickedLng, clickedLat] = e.coordinate;
      lng.value = clickedLng;
      lat.value = clickedLat;
      emit("submit", { latitude: clickedLat, longitude: clickedLng });
    }

    const tiles = tileSource(static_store.maptiler_key);
    return { lat, lng, center, zoomLevel, handleMapClick, mapRef, tiles };
  },
};
</script>

<style scoped>
.birthplace-map-widget {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
}

.birthplace-map-widget p {
  font-size: 0.75rem;
  text-align: center;
  color: #999;
  margin: 0 0 4px;
}

.map-wrapper {
  position: relative;
  width: 100%;
  flex: 1;
  min-height: 160px;
}

.map-overlay-confirm {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(255, 255, 255, 0.96);
  border-radius: 12px;
  padding: 12px 16px;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.15);
  max-width: 90%;
  text-align: center;
  z-index: 100;
  font-size: 0.85rem;
}

.map-overlay-confirm .note {
  font-size: 0.75rem;
  color: #777;
  margin: 4px 0 8px;
}

button {
  margin-top: 6px;
  background-color: #663399;
  color: white;
  border-radius: 6px;
  padding: 6px 14px;
  cursor: pointer;
  font-size: 0.85rem;
}

button:hover {
  background-color: #5a2d85;
}

</style>
